import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ToolbarCollectionErrorStateUniDriver } from '../ErrorState/ToolbarCollectionErrorState.uni.driver';
import { ToolbarCollectionEmptyStateUniDriver } from '../EmptyState/ToolbarCollectionEmptyState.uni.driver';
import { CollectionToolbarUniDriver } from '../CollectionToolbar/CollectionToolbar.uni.driver';
import { AppliedFiltersTagListUniDriver } from '../AppliedFiltersTagList/AppliedFiltersTagList.uni.driver';
import InfiniteScrollTableUniDriver from '../InfiniteScrollTable/InfiniteScrollTable.uni.driver';
import { NestedTableParentCellUniDriver } from './NestedTableParentCell.uni.driver';
import { NestedTableFlatModeMainCellUniDriver } from './NestedTableFlatModeMainCell.uni.driver';
import { NestedTableRowPlaceholderStatesUniDriver } from './NestedTableRowPlaceholderStates.uni.driver';
import { CollectionItemActionsUniDriver } from '../CollectionItemActions/CollectionItemActions.uni.driver';
import { SummaryBarUniDriver } from '../SummaryBar/SummaryBar.uni.driver';

export function NestedTableUniDriver(base: UniDriver, body: UniDriver) {
  const toolbarBase = () => base.$('[data-hook="collection-toolbar"]');

  const toolbar = () => CollectionToolbarUniDriver(toolbarBase(), body);

  const table = InfiniteScrollTableUniDriver(base, body);

  const loadingStateExists = () =>
    base.$('[data-hook="placeholder-states-loading-state"]').exists();
  const getSummaryBar = () => SummaryBarUniDriver(base, body);

  return {
    ...table,
    toolbar: () => toolbar(),
    loadingStateExists,
    /** @deprecated use loadingStateExists */
    refreshLoaderExists: loadingStateExists,
    /** @deprecated use loadingStateExists */
    initialLoaderExists: loadingStateExists,
    getRootErrorStateByDataHook: (
      dataHook = 'placeholder-states-error-state',
    ) =>
      ToolbarCollectionErrorStateUniDriver(
        base.$(`[data-hook="${dataHook}"]`),
        body,
      ),
    getRootEmptyStateByDataHook: (
      dataHook = 'placeholder-states-empty-state',
    ) =>
      ToolbarCollectionEmptyStateUniDriver(
        base.$(`[data-hook="${dataHook}"]`),
        body,
      ),
    subToolbar: () =>
      AppliedFiltersTagListUniDriver(
        base.$('[data-hook="collection-table-sub-toolbar"]'),
        body,
      ),

    isRowExpandable: async (rowKey: string) =>
      (await table._getRowByKey(rowKey).attr('class'))?.includes('expandable'),

    getMainColumnAt: (row: number) =>
      NestedTableParentCellUniDriver(
        table._getCellByRowIndexAndCellKey(row, 'nested-mode-main-column'),
        body,
      ),

    getActionsCellByKey: (rowKey: string) =>
      CollectionItemActionsUniDriver(table._getRowByKey(rowKey), body),

    getMainColumnByKey: (rowKey: string) =>
      NestedTableParentCellUniDriver(
        table._getCellByKey(rowKey, 'nested-mode-main-column'),
        body,
      ),

    getFlatModeMainColumnByKey: (rowKey: string) =>
      NestedTableFlatModeMainCellUniDriver(
        table._getCellByKey(rowKey, 'flat-mode-main-column'),
        body,
      ),

    getFlatModeMainColumnAt: (row: number) =>
      NestedTableFlatModeMainCellUniDriver(
        table._getCellByRowIndexAndCellKey(row, 'flat-mode-main-column'),
        body,
      ),

    getPlaceholderStatesByRowKey: (rowKey: string) =>
      NestedTableRowPlaceholderStatesUniDriver(
        table._getRowByKey(`placeholder-states-${rowKey}`),
        body,
      ),
    /**
     * Gets collection summary bar
     */
    getSummaryBar,
  };
}

export default NestedTableUniDriver;
